import type { AddressSearchLabels, LocationRestriction } from './types';

export const GOOGLE_MAPS_API_KEY = 'AIzaSyAG5K6T2w0hcwh7sSgNigOktBulwDYdAOg';

export const AUTOCOMPLETE_ENDPOINT = 'https://places.googleapis.com/v1/places:autocomplete';
export const PLACE_DETAILS_ENDPOINT = 'https://places.googleapis.com/v1/places';

export const DEBOUNCE_MS = 500;
export const MIN_QUERY_LENGTH = 3;
export const MAX_CACHE_SIZE = 50;
export const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
export const DEFAULT_INCLUDED_PRIMARY_TYPES: string[] = [];
export const DEFAULT_REGION_CODE = 'CA';

export const DEFAULT_LOCATION_RESTRICTION: LocationRestriction = {
  rectangle: {
    low: { latitude: 20, longitude: -180 },
    high: { latitude: 90, longitude: -20 },
  },
};

export const DEFAULT_LABELS_EN: AddressSearchLabels = {
  question: '',
  placeholder: 'Address',
  searching: 'Searching',
  warning: 'Warning!',
  missingApiKey: 'Missing Google Maps API key.',
  fetchSuggestionsError: 'Unable to fetch address suggestions.',
  fetchDetailsError: 'Unable to fetch place details.',
  outsideArea: 'Selected location is outside the supported area.',
  missingLocation: 'Selected place is missing location data.',
};

export const DEFAULT_LABELS_FR: AddressSearchLabels = {
  question: '',
  placeholder: 'Adresse',
  searching: 'Recherche en cours',
  warning: 'Attention!',
  missingApiKey: 'Clé API Google Maps manquante.',
  fetchSuggestionsError: "Impossible de récupérer les suggestions d'adresse.",
  fetchDetailsError: 'Impossible de récupérer les détails du lieu.',
  outsideArea: "L'emplacement sélectionné se trouve en dehors de la zone prise en charge.",
  missingLocation: 'Les données de localisation sont manquantes pour le lieu sélectionné.',
};

export const getDefaultLabels = (languageCode: string): AddressSearchLabels =>
  languageCode === 'fr' ? DEFAULT_LABELS_FR : DEFAULT_LABELS_EN;
